import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography, { TypographyProps } from '@mui/material/Typography';

type LabelWithIconProps = {
  icon: React.ReactNode;
  text: string;
  onEdit?: () => void;
  variant?: TypographyProps['variant'];
};

const LabelWithIcon: React.FC<LabelWithIconProps> = ({
  icon,
  text,
  onEdit,
  variant = 'subtitle1',
}) => (
  <Box display="flex" alignItems="center" justifyContent="space-between">
    <Box display="flex" alignItems="center">
      {icon}
      <Typography
        variant={variant}
        sx={{ ml: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {text}
      </Typography>
    </Box>
    <IconButton size="small" onClick={onEdit} aria-label="Edit" disabled={!onEdit}>
      <EditIcon fontSize="small" />
    </IconButton>
  </Box>
);

export default LabelWithIcon;
